export interface LoginStateInterface {
  authenticated: boolean;
  email: string;
  role: string;
  organizationId: string;
  temporaryEmail: string;
}

const state: LoginStateInterface = {
  authenticated: false,
  email: '',
  role: '',
  organizationId: '',
  temporaryEmail: '',
};

export default state;
